import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface OlarkState {
  isInChatPage: boolean;
}

const initialState: OlarkState = {
  isInChatPage: false,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    enterChatPage(state) {
      state.isInChatPage = true;
    },
    exitChatPage(state) {
      state.isInChatPage = false;
    },
  },
});

export const { enterChatPage, exitChatPage } = chatSlice.actions;
export default chatSlice.reducer;

export const selectIsInChatPage = (state: RootState) => state.chat.isInChatPage;
